module.exports = __webpack_public_path__ + "static/media/SS1.21f776da.jpg";